// extracted by mini-css-extract-plugin
module.exports = {"image":"ProjectItem-module--image--O6hPq","root":"ProjectItem-module--root--15UAr","arrow":"ProjectItem-module--arrow--1J1CM"};